import React, { createContext, useContext, useMemo, useState } from 'react';

// Modo auditoria: ligado só pela tela /audit/view. As telas de questionário por
// tipo (Questionnaire, DiagnosisType, PeriodicType, *Certification) são as
// mesmas usadas na visualização normal do painel — o contexto evita passar
// prop por dentro das cinco.
//
// EG-63: além de `canScore`/`isScoreDisabled`, o contexto agora carrega o
// `headerData` que cada renderer publica (progresso, ações de download, "ver
// como respondente") para o `AuditHeader` único montar o cabeçalho — antes cada
// renderer desenhava o seu, empilhado embaixo do header do AuditView.
const AuditModeContext = createContext(null);

export function AuditModeProvider({ value, children }) {
 const [headerData, setHeaderData] = useState(null);

 const merged = useMemo(
  () => ({
   ...value,
   // Em auditoria o renderer não desenha o próprio sub-header; quem monta é o
   // AuditHeader a partir do que for publicado aqui.
   hideInlineHeader: true,
   headerData,
   setHeaderData,
  }),
  [value, headerData]
 );

 return (
  <AuditModeContext.Provider value={merged}>{children}</AuditModeContext.Provider>
 );
}

export function useAuditMode() {
 return useContext(AuditModeContext);
}
